import cookies from '@utils/cookies';
import { LOGIN_SOURCE_IFRAME } from '../constants';

const setCookiesPostLogin = (loginResponseResult, source) => {
  cookies.eraseCookie('anonymous_session_id');
  cookies.eraseCookie('partialUserAccessToken');
  cookies.setCookie(
    'accessToken',
    loginResponseResult.access_token,
    3024000,
    true,
    source === LOGIN_SOURCE_IFRAME
  );
  cookies.setCookie(
    'refreshToken',
    loginResponseResult.refresh_token,
    3024000,
    true,
    source === LOGIN_SOURCE_IFRAME
  );
  cookies.eraseCookie('selectedGoalUid');
};

export default setCookiesPostLogin;
